var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeighborhood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 17.5034H1.66406",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0859 14.6909V17.5034",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 11.2533C19.1667 10.1027 18.234 9.16992 17.0834 9.16992C15.9328 9.16992 15.0001 10.1027 15.0001 11.2533L15 12.3861C15 13.5367 15.9327 14.4694 17.0833 14.4694C18.2339 14.4694 19.1667 13.5367 19.1667 12.3861L19.1667 11.2533Z",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83594 17.5033V3.5606C5.83594 2.52507 6.6754 1.6856 7.71094 1.6856H13.5443C14.5798 1.6856 15.4193 2.52507 15.4193 3.5606V6.25332",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62242 8.33691H3.53906C2.50353 8.33691 1.66406 9.17638 1.66406 10.2119V17.5036",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 17.5036V13.6494C9.0625 12.7865 9.76206 12.0869 10.625 12.0869V12.0869C11.4879 12.0869 12.1875 12.7865 12.1875 13.6494V17.5036",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 8.89453H12.1875",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 5.83545H12.1875",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNeighborhood;